//权限管理
import http from '../jslibs/axios/http';

// 权限管理 用户列表
export const getAuthList = data => http.get('/cms/AdminUser', data);

// 权限管理 新增用户
export const addAdminUser = data => http.post('/cms/AdminUser', data);

// 权限管理 编辑用户
export const editAuthUser = data => http.put(`/cms/AdminUser/${data.uuid}`, data);
// 权限管理 删除用户
export const delAuthUser = uuid => http.delete(`/cms/AdminUser/${uuid}`);
// 权限管理 获取用户详情
export const getAuthListDetail = uuid => http.get(`/cms/AdminUser/${uuid}`);

// 权限管理 获取权限列表
export const LimitsList = data => http.get('/cms/AdminAuthMenu', data);

// 权限管理 获取身份列表
export const identityOf = data => http.get('/cms/AdminAuthGroup', data);
// 权限管理 添加身份
export const addLimitsUser = data => http.post('/cms/AdminAuthGroup', data);
// 权限管理 编辑身份
export const SetLimitsList = data => http.put(`/cms/AdminAuthGroup/${data.id}`, data);
// 权限管理 删除身份
export const delLimitsUser = id => http.delete(`/cms/AdminAuthGroup/${id}`);
// 权限管理 获取身份详情
export const getIdentityDetail = id => http.get(`/cms/AdminAuthGroup/${id}`);